import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoOutlook = () => {
  return (
    <g>
      <path d="m11.9909 7.834a1.5044 1.5044 0 0 1 -2.075-.2048v4.0976h5.1559s.7546-.1049.6917-1.0947l.0037-5.3533z" />
      <path d="m15.7254 3.9976a.571.571 0 0 0 -.6116-.6243h-5.1979v3.046l1.1108.7081z" />
      <ellipse cx="4.7894" cy="7.8613" rx=".998" ry="1.6371" />
      <path d="m.2328 14.0021 9.1172 1.7864v-15.577l-9.1172 1.5732zm4.581-8.8994c1.1464 0 2.0757 1.237 2.0757 2.763s-.9294 2.763-2.0757 2.763-2.0759-1.2369-2.0759-2.7629.9294-2.763 2.0758-2.763z" />
    </g>
  );
};

export default withIcon(IconLogoOutlook);
